import { App, h } from 'vue';
// import 'xe-utils';
import dayjs from 'dayjs';
import { isFunction } from '@/utils/is';
import {
  // 全局对象
  VXETable,

  // 表格功能
  // Filter,
  // Edit,
  // Menu,
  // Export,
  // Keyboard,
  // Validator,

  // 可选组件
  Icon,
  Column,
  Colgroup,
  Grid,
  Tooltip,
  // Toolbar,
  Pager,
  // Form,
  // FormItem,
  // FormGather,
  // Checkbox,
  // CheckboxGroup,
  // Radio,
  // RadioGroup,
  // RadioButton,
  // Switch,
  Input,
  Select,
  // Optgroup,
  Option,
  // Textarea,
  // Button,
  // Modal,
  // List,
  // Pulldown,

  // 表格
  Table,
} from 'vxe-table';
import { accMul, formatAmount, formatterRound } from '@/utils/common';
import { storeToRefs } from 'pinia';
import { useUserStore } from '@/store';
import globalContants from '@/constants/globalContants';

// import zhCN from 'vxe-table/es/locale/lang/zh-CN';

// 按需加载的方式默认是不带国际化的，自定义国际化需要自行解析占位符 '{0}'，例如：
// VXETable.setup({
//   i18n: (key, args) => XEUtils.toFormatString(XEUtils.get(zhCN, key), args),
// });
const userStore = useUserStore();
const { materialDecimal } = storeToRefs(userStore);
VXETable.config({
  size: 'mini',
  table: {
    minHeight: 0,
  },
});
const formatMethods: Recordable = {
  dateFormatter({ cellValue }, format) {
    if (!cellValue) return '-';
    cellValue = dayjs(cellValue).format(format || 'YYYY-MM-DD HH:mm:ss');
    return `${cellValue}`;
  },
  decoFormatter({ cellValue }, prefix = '', suffix = '') {
    if (!cellValue && cellValue !== 0) return '-';
    return `${prefix}${cellValue}${suffix}`;
  },
  priceFormatter(
    { cellValue, column },
    notCurrencySymbol = false,
    defaultVal = undefined
  ) {
    if (cellValue) {
      return `${formatAmount(
        cellValue,
        notCurrencySymbol,
        materialDecimal.value
      )}`;
    }
    if (column?.params?.params?.defaultShowVal) {
      defaultVal = column.params.params.defaultShowVal;
    }
    if (defaultVal === undefined || defaultVal === null) {
      defaultVal = '-';
    }
    return cellValue === 0 ? `${globalContants.CURRENCYSYMBOL}0` : defaultVal;
  },
  enumFormatter({ cellValue }, enumData) {
    return enumData[cellValue];
  },
  specFormatter({ cellValue }, field = 'propertyValue') {
    if (!Array.isArray(cellValue)) return '-';
    return cellValue.map((item: any) => item[field]).join('-');
  },
  amountFormatter(
    { row },
    fields = ['number', 'price'],
    decimal = 2,
    prefix = ''
  ) {
    return `${prefix}${formatterRound(
      accMul(Number(row[fields[0]] || 0), Number(row[fields[1]] || 0)),
      decimal
    )}` as any;
  },
};

Object.keys(formatMethods).forEach((method) => {
  VXETable.formats.add(method, {
    cellFormatMethod: formatMethods[method],
  });
});

VXETable.renderer.add('Tag', {
  renderDefault(_, renderParams) {
    const { row, column } = renderParams;
    const { params } = column.params;

    if (!row[column.field]) {
      return '-';
    }
    return h(
      'div',
      {
        class: params?.find(
          (item: Recordable) => item.val === row[column.field]
        )?.color,
      },
      params?.find((item: Recordable) => item.val === row[column.field])
        ?.text ?? '-'
    );
  },
});

// 用于给单元格添加动态类名
VXETable.renderer.add('Class', {
  renderDefault(_, renderParams) {
    const { row, column } = renderParams;
    const { params } = column.params;

    const cellValue = isFunction(column.formatter)
      ? column.formatter({ cellValue: row[column.field], row, column })
      : row[column.field];
    const cellClass = isFunction(params)
      ? params({ cellValue, row, column })
      : params;

    return h(
      'div',
      {
        class: cellClass,
      },
      cellValue
    );
  },
});

export default function useTable(app: App) {
  // 表格功能
  // app.use(Filter)
  // .use(Edit)
  // .use(Menu)
  // .use(Export)
  // .use(Keyboard)
  // .use(Validator)

  // 可选组件
  app
    .use(Icon)
    .use(Column)
    .use(Colgroup)
    .use(Grid)
    .use(Tooltip)
    // .use(Toolbar)
    .use(Pager)
    // .use(Form)
    // .use(FormItem)
    // .use(FormGather)
    // .use(Checkbox)
    // .use(CheckboxGroup)
    // .use(Radio)
    // .use(RadioGroup)
    // .use(RadioButton)
    // .use(Switch)
    .use(Input)
    .use(Select)
    // .use(Optgroup)
    .use(Option)
    // .use(Textarea)
    // .use(Button)
    // .use(Modal)
    // .use(List)
    // .use(Pulldown)

    // 安装表格
    .use(Table);
}
